// Locale-aware formatters used across resource pages so we have one place to
// tweak when the design team decides decimals/separators should change.

import dayjs from 'dayjs';

/** Convert cents (BIGINT) to a human ¥ amount, fixed 2 decimals. */
export function formatCNY(cents: number | string | null | undefined): string {
  if (cents === null || cents === undefined || cents === '') return '-';
  const n = typeof cents === 'string' ? Number(cents) : cents;
  if (!Number.isFinite(n)) return '-';
  return `¥${(n / 100).toFixed(2)}`;
}

/** ISO/Date → YYYY-MM-DD HH:mm. Empty input renders as `-`. */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '-';
  const d = dayjs(value);
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm') : String(value);
}

/** Same as formatDateTime but date-only. */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '-';
  const d = dayjs(value);
  return d.isValid() ? d.format('YYYY-MM-DD') : String(value);
}

/** Truncate long ids/strings for table display. */
export function truncate(value: string | null | undefined, n = 12): string {
  if (!value) return '-';
  return value.length > n ? `${value.slice(0, n)}…` : value;
}
